/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';

function ManageFlightBooking({ flightRecord }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const getFlightTicket = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const getFlightResheduleRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_RESHEDULE_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const getFlightCancellationRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_CANCELLATION_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  return (
    <div className="overflow-auto fs-14 table-responsive">
      {flightRecord && flightRecord.length > 0 && (
        <table className="table fs-12 table-bordered">
          <thead>
            <tr>
              <th>{formattedMessage('txid')}</th>
              <th>{formattedMessage('sector')}</th>
              <th>Booking Date</th>
              <th>{formattedMessage('passenger_name')}</th>
              <th>{formattedMessage('gds_pnr')}</th>
              <th>{formattedMessage('airline_pnr')}</th>
              <th>{formattedMessage('booking_status')}</th>
              <th>{formattedMessage('ticket')}</th>
              <th>{formattedMessage('cancel')}</th>
              <th>{formattedMessage('reshedule')}</th>
            </tr>
          </thead>
          <tbody>
            {flightRecord.map((x, index) => (
              <tr key={index}>
                <td>{x.Txid}</td>
                <td>
                  {x.Origin} - {x.Destination}
                </td>
                <td>{x.BookingDate}</td>
                <td>{`${x.PassengerFirstName} ${x.PassengerLastName}`}</td>
                <td>{x.GdsPnr}</td>
                <td>{x.AirlinePnr.split(',')[0]}</td>
                <td>{x.BookingStatus}</td>
                <td>
                  <AppLink
                    linkText={formattedMessage('ticket')}
                    isLink
                    target="_blank"
                    href={getFlightTicket(x.Txid)}
                  />
                </td>
                <td>
                  {x.BookingStatus.toLowerCase() === 'confirmed' && (
                    <AppLink
                      linkText={formattedMessage('cancel')}
                      isLink
                      target="_blank"
                      href={getFlightCancellationRoute(x.Txid)}
                    />
                  )}
                </td>
                <td>
                  {x.BookingStatus.toLowerCase() === 'confirmed' && (
                    <AppLink
                      linkText={formattedMessage('reshedule')}
                      isLink
                      target="_blank"
                      href={getFlightResheduleRoute(x.Txid)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

ManageFlightBooking.propTypes = {
  flightRecord: PropTypes.object.isRequired,
};

export default ManageFlightBooking;
